import { getField, updateField } from "vuex-map-fields";
// import router from "../../../router";
const timerSeconds = 60;
let tid = new Object();

const getDefaultState = () => {
  return {
    /**
     * 인증코드 입력 남은 시간
     */
    sendTime: 0,
    supplError: {
      active: false,
      errCode: "",
      errMsg: "",
      errBtnText: "",
      errBtnAction: "",
    },
    NOS_INSTANCE: {},
    // 추가인증수단 컴포넌트 오픈 - tokenOTP, mOtp, advancedOTP
    isOpenSupplCertn: false,
    // 인증공통 데이터 - 인터넷뱅킹과 구조가 같아야 함.
    supplCertn: {
      // 추가인증수단 구분코드(004, 304, 701..)
      certnMethdDstcd: "",
      // mOTP(701)
      mOTP: {
        mOtpNm: "",
        certnDmndCd: "",
      },
      fido: {
        result: "",
        uafResponse: "",
        errorcode: "",
        failcount: "",
        fidoid: "",
      },
      advancedOTP: {
        chlgeVal: "",
        synczModDstcd: "",
      },
    },
    /**
     * 업무거래 파라미터
     */
    bizPayload: {
      callUrl: "",
      postData: {},
      succ: null,
      fail: null,
      final: null,
      autoErrorShow: true,
    },
    cmmCertn: {
      bizDscdForNosKeypadOtp: "", // NOSKeypadOTP 구분코드
      svrInfo: {
        success: {
          scurtyDeviVndrDstcd: "", // 000, PINCODE, FINGERPRINT, 004, 701, 304RO, 304CR, NON_CERTN
          systemId: "",
          chlgeVal: "", // advancedOTP 챌린지 값
          fidoCertnUafResDTO: {
            statusCode: "",
            bioType: "",
            userName: "",
            systemId: "",
            fidoReqMessage: {
              statusCode: "",
              uafRequest: "",
              op: "",
              lifetimeMillis: "",
            },
            Device: null,
          },
          mOtpInfo: {
            operGroupCd: "",
            iD: "",
            otpStusDstcd: "",
            coprPpsnDstcd: "",
            cin: "",
            wWWBnkgLginID: "",
            mchtlUniqNo: "",
            pinFailNotms: 0,
            certnErrNotms: 0,
            totalCertnSucssNotms: 0,
            totalCertnErrNotms: 0,
            frstCertnSucssLcalYMS: "",
            lastCertnDmndLcalYMS: "",
            lastCertnSucssLcalYMS: "",
            lastCertnErrLcalYMS: "",
            issuncLcalYMS: "",
            frstCertnSucssYMS: "",
            lastCertnDmndYMS: "",
            lastCertnSucssYMS: "",
            lastCertnErrYMS: "",
            issuncYMS: "",
            smphMchtlUniqNo: "",
            smphMchtlDstcd: "",
            pgmVsnno: "",
            certnDmndCd: "",
            smphMdelName: "",
            writYMS: "",
            lastAmndYMS: "",
            rmark: "",
            id: "",
            wwwbnkgLginID: "",
          },
          fidoInfo: {
            operGroupCd: "",
            fIDOID: "",
            coprPpsnDstcd: "",
            cin: "",
            wWWBnkgLginID: "",
            pinRegiYMS: "",
            pinFailNotms: "",
            pinStusDstcd: "",
            pinStusModfiYMS: "",
            fngprRegiDstcd: "",
            fngprStusLastModfiYMS: "",
            smphMchtlUniqNo: "",
            smphMchtlDstcd: "",
            pgmVsnno: "",
            smphMdelName: "",
            writYMS: "",
            lastAmndYMS: "",
            rmark: "",
            fidoid: "",
            wwwbnkgLginID: "",
          },
        },
        fail: {},
      },
      appInfo: {
        /**
         * 기기에 등록된 mOtp 사용자 정보
         */
        SSInfogetMotp: {
          in: {},
          out: [
            // {
            // 	strUserId: "G21000009100000"
            // , secret: "dfefewfsdfadsafasdfasdfsdf...."
            // }
          ],
        },
        /**
         * 기기에 등록된 fido 사용자 정보
         */
        fidoRegInfo: {
          in: {},
          out: [
            // {"userName": "mOTP아이디", “isPincode”: “0/1”, “isFingerprint”: “0/1”, "isPattern":"0/1"}
          ],
        },
        /**
         * APP 인증코드 콜백데이터
         */
        SSGenerateMotp: {
          result: "", // 결과코드
          motp: "", // mOTP난수
          errorcode: "", // 에러코드
          failcount: "", // mPin 오류횟수
        },
      },
    },
    /**
     * 업무거래 파라미터 중 commAuth 데이터
     */
    commAuth: {
      biz: "", // config.js AUTH_01 등....참조..
      bizParam: {
        amt: "", // 이체금액
        acno: "", // 출금계좌
        userIdnfr: "", // 사용자식별자(비로그인 거래시..)
      },
    },
  };
};

const supplCertn = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    getSupplCertn: state => {
      return state;
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    mut001supplCertn: function(state, payload) {
      state.isOpenSupplCertn = payload;
    },
    // NOS_INSTANCE 업데이트함.
    mut002supplCertn: function(state, payload) {
      state.NOS_INSTANCE = payload;
    },
    // mOtp 기기정보를 업데이트 함.
    mut003supplCertn: function(state, payload) {
      state.cmmCertn.appInfo.SSInfogetMotp.out = [];
      payload.Motpinfo.length > 0 &&
        payload.Motpinfo.forEach(e => {
          state.cmmCertn.appInfo.SSInfogetMotp.out.push(e);
        });
    },
    // app인증코드 콜백데이터를 업데이트 함.
    mut004supplCertn: function(state, payload) {
      this._vm.$set(state.cmmCertn.appInfo.SSGenerateMotp, payload.key, payload.value);
    },
    // mOTP 인증번호 갱신
    mut005supplCertn: state => {
      Object.assign(state.cmmCertn.appInfo.SSGenerateMotp, getDefaultState().cmmCertn.appInfo.SSGenerateMotp);
    },
    /**
     * 기기에 등록된 fido 사용자 정보 결과를 업데이트 함.
     */
    mut006supplCertn: function(state, payload) {
      state.cmmCertn.appInfo.fidoRegInfo.out = [];
      payload.Fidoinfo.length > 0 &&
        payload.Fidoinfo.forEach(e => {
          state.cmmCertn.appInfo.fidoRegInfo.out.push(e);
        });
    },
  },
  actions: {
    /**
     * 인증공통 시작..
     */
    act001supplCertn: async function(context, payload) {
      // 인증 초기화
      Object.assign(context.state.cmmCertn, getDefaultState().cmmCertn);

      // 업무 거래 파라미터 저장
      this.state.common.supplCertn.bizPayload = payload;

      // 업무 파라미터 중 commAuth 저장
      this.state.common.supplCertn.commAuth = _.merge(this.state.common.supplCertn.commAuth, payload.postData.commAuth);

      // 기기의 mOTP, FIDO 정보조회
      // act005supplCertn -> brige(motp조회) -> act006supplCertn -> bridge(fido조회) -> act007supplCertn
      context.dispatch("act005supplCertn", "SSInfogetMotp_supplCertn"); // 기기의 mOtp정보 조회
    },
    /**
     * 인증공통 정상처리 된 경우, 업무거래 실행..
     * @param {*} context
     */
    act002supplCertn: function(context) {
      // 키패드 데이터 최종 update
      this.state.common.supplCertn.bizPayload.postData._nprotected = this.state.common.supplCertn.NOS_INSTANCE.toJSON();
      // 실행거래에서는 인증공통 예외 처리함.
      delete this.state.common.supplCertn.bizPayload.postData.commAuth;

      // mOTP 데이터 set
      context.state.supplCertn.mOTP.mOtpNm = context.state.cmmCertn.appInfo.SSGenerateMotp.motp;
      context.state.supplCertn.mOTP.certnDmndCd = context.state.cmmCertn.svrInfo.success.mOtpInfo.certnDmndCd;

      // fido 데이터 set
      context.state.supplCertn.fido.result = this.state.auth.createFido.fidoCertn.appReq.out.result;
      context.state.supplCertn.fido.uafResponse = this.state.auth.createFido.fidoCertn.appReq.out.uafResponse;
      context.state.supplCertn.fido.errorcode = this.state.auth.createFido.fidoCertn.appReq.out.errorcode;
      context.state.supplCertn.fido.failcount = this.state.auth.createFido.fidoCertn.appReq.out.failcount;
      context.state.supplCertn.fido.fidoid = this.state.auth.createFido.fidoCertn.appReq.in.userName;

      // 인증공통 데이터 set
      this.state.common.supplCertn.bizPayload.postData._nprotected._supplCertn = context.state.supplCertn;
      // this._vm.$log.info("_supplCertn >>> " + this.state.common.supplCertn.bizPayload.postData._nprotected._supplCertn);
      this._vm.$post(
        this.state.common.supplCertn.bizPayload.callUrl,
        this.state.common.supplCertn.bizPayload.postData,
        this.state.common.supplCertn.bizPayload.succ,
        this.state.common.supplCertn.bizPayload.fail,
        this.state.common.supplCertn.bizPayload.final,
        this.state.common.supplCertn.bizPayload.autoErrorShow,
      );
    },
    /**
     * native bridge call
     */
    act005supplCertn: function(context, payload) {
      switch (payload) {
        case "SSInfogetMotp_supplCertn":
          this._vm.$bridge.SSInfogetMotp_supplCertn();
          break;
        case "fidoRegInfo_supplCertn":
          this._vm.$bridge.fidoRegInfo_supplCertn();
          break;
        case "SSGenerateMotp_supplCertn":
          this._vm.$bridge.SSGenerateMotp_supplCertn({
            strUserId: this.state.common.supplCertn.cmmCertn.svrInfo.success.mOtpInfo.iD,
            strPeriod: "1",
            strSystemId: this.state.common.supplCertn.cmmCertn.svrInfo.success.systemId,
          });
          break;
        case "SSGenerateMotp_supplCertn_ReGenerate":
          this._vm.$bridge.SSGenerateMotp_supplCertn_ReGenerate({
            strUserId: this.state.common.supplCertn.cmmCertn.svrInfo.success.mOtpInfo.iD,
            strPeriod: "1",
            strSystemId: this.state.common.supplCertn.cmmCertn.svrInfo.success.systemId,
          });
          break;
      }
    },
    /**
     * SSInfogetMotp_supplCertn(기기의 mOtp정보조회)
     * @param {*} context
     */
    act006supplCertn: function(context) {
      context.dispatch("act005supplCertn", "fidoRegInfo_supplCertn");
    },
    /**
     * 인증수단 체크 서버 호출
     * @param {*} context
     */
    act007supplCertn: async function(context) {
      let result = "";
      const payload = {
        bizCommAuth: this.state.common.supplCertn.commAuth,
        sSInfogetMotp: this.state.common.supplCertn.cmmCertn.appInfo.SSInfogetMotp,
        fidoRegInfo: this.state.common.supplCertn.cmmCertn.appInfo.fidoRegInfo,
        smphMchtlUniqNo: this.state.native.smphMchtlUniqNo,
        scurtyDeviVndrDstcd: this.state.common.supplCertn.commAuth.bizParam.scurtyDeviVndrDstcd, // 비로그인 인경우..
      };
      if (this.getters.isLogin) {
        result = await context.dispatch("act014supplCertn", payload); // 로그인
      } else {
        result = await context.dispatch("act015supplCertn", payload); // 비로그인
      }

      if (result === "success") {
        // this._vm.$log.info(JSON.stringify(context.state.cmmCertn.svrInfo.success));
        switch (context.state.cmmCertn.svrInfo.success.scurtyDeviVndrDstcd) {
          case this._vm.$config.SCURTY_DEVI_VNDR_DSTCD_FIDO_PINCODE:
            // bridge -> act016supplCertn
            this._vm.$bridge.fidoCertn_supplCertn(context.state.cmmCertn.svrInfo.success.fidoCertnUafResDTO);
            break;
          case this._vm.$config.SCURTY_DEVI_VNDR_DSTCD_FIDO_FINGERPRINT:
            this.state.auth.createFido.fidoActionSheetTitle = this.state.native.biometryTypeIos === "faceId" ? "MLGI-06-01-04-01" : "MLGI-06-01-03-01";
            this.state.auth.createFido.fidoActionSheetContent = this.state.native.biometryTypeIos === "faceId" ? "MLGI-06-01-04-02" : "MLGI-06-01-03-02";
            this.state.auth.createFido.isFidoActionSheetError = false;
            this.state.auth.createFido.isFidoActionSheetOpen = true;
            // bridge -> act016supplCertn
            this._vm.$bridge.fidoCertn_supplCertn(context.state.cmmCertn.svrInfo.success.fidoCertnUafResDTO);
            break;
          case this._vm.$config.SCURTY_DEVI_VNDR_DSTCD_004: // tokenOTP
            this.state.common.supplCertn.isOpenSupplCertn = true;
            break;
          case this._vm.$config.SCURTY_DEVI_VNDR_DSTCD_701: // mOTP
            // act007supplCertn -> brige -> act009supplCertn
            context.dispatch("act005supplCertn", "SSGenerateMotp_supplCertn"); // mOtp 난수생성
            break;
          case this._vm.$config.SCURTY_DEVI_VNDR_DSTCD_304RO: // advancedOTP - RO
            this.state.common.supplCertn.supplCertn.advancedOTP.synczModDstcd = "RO";
            this.state.common.supplCertn.supplCertn.advancedOTP.chlgeVal = "";
            this.state.common.supplCertn.isOpenSupplCertn = true;
            break;
          case this._vm.$config.SCURTY_DEVI_VNDR_DSTCD_304CR: // advancedOTP - CR
            this.state.common.supplCertn.supplCertn.advancedOTP.synczModDstcd = "CR";
            this.state.common.supplCertn.supplCertn.advancedOTP.chlgeVal = context.state.cmmCertn.svrInfo.success.chlgeVal;
            this.state.common.supplCertn.isOpenSupplCertn = true;
            break;
          case this._vm.$config.SCURTY_DEVI_VNDR_DSTCD_NON_CERTN:
            context.dispatch("act002supplCertn");
            break;
          case this._vm.$config.SCURTY_DEVI_VNDR_DSTCD_000:
            /*
              MOTP-04-01-07-05 : 오류 발생
              MOTP-CERTN-25 : 사용 가능한 OTP 보안 매체가 없습니다. 영업점을 방문해주시기 바랍니다.
            */
            context.dispatch("act008supplCertn", {
              code: "MOTP-04-01-07-05",
              msg: "MOTP-CERTN-25",
              errBtnText: "",
              errBtnAction: "",
            });
            break;
          default:
            /*
              MOTP-04-01-06-07 : mOTP 인증 실패
              MOTP-CERTN-15 : 유효한 인증수단이 없습니다.
            */
            context.dispatch("act008supplCertn", {
              code: "MOTP-04-01-06-07",
              msg: "MOTP-CERTN-15",
              errBtnText: "",
              errBtnAction: "",
            });
            break;
        }
      }

      if (result === "fail" && !_.isNil(this.state.common.supplCertn.bizPayload.fail) && typeof this.state.common.supplCertn.bizPayload.fail === "function") {
        this.state.common.supplCertn.bizPayload.fail(this.state.common.supplCertn.cmmCertn.svrInfo.fail);
      }
    },
    /**
     * 인증공통 error popup
     */
    act008supplCertn: function(context, payload) {
      this.state.common.supplCertn.supplError.active = true;
      this.state.common.supplCertn.supplError.errCode = payload.code;
      this.state.common.supplCertn.supplError.errMsg = payload.msg;
      this.state.common.supplCertn.supplError.errBtnText = payload.errBtnText;
      this.state.common.supplCertn.supplError.errBtnAction = payload.errBtnAction;
    },
    /**
     * ★★★★★★ native callback ★★★★★★
     * mOTP PC인증 app 호출 성공시..
     * 실패횟수가 4회 이하인 경우 - 인증번호 팝업을 열고
     * 실패횟수가 5회 이상인 경우 - mOTP상태코드 변경.
     */
    act009supplCertn: function(context, payload) {
      if (payload === "SUCCESS") {
        // context.dispatch("act003");
        if (context.state.cmmCertn.svrInfo.success.mOtpInfo.certnDmndCd === "1") {
          // 자동 - 거래실행 ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
          context.dispatch("act002supplCertn");
        } else if (context.state.cmmCertn.svrInfo.success.mOtpInfo.certnDmndCd === "2") {
          // 수동 - 키패드 오픈 ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
          this.state.common.supplCertn.sendTime = timerSeconds;
          clearInterval(tid);
          this.state.common.supplCertn.isOpenSupplCertn = true;
          context.dispatch("act012supplCertn");
        }
      }

      if (payload === "ERROR") {
        let isError = true;

        if (
          Number(this.state.common.supplCertn.cmmCertn.appInfo.SSGenerateMotp.failcount) === 1 ||
          Number(this.state.common.supplCertn.cmmCertn.appInfo.SSGenerateMotp.failcount) === 2 ||
          Number(this.state.common.supplCertn.cmmCertn.appInfo.SSGenerateMotp.failcount) === 3 ||
          Number(this.state.common.supplCertn.cmmCertn.appInfo.SSGenerateMotp.failcount) === 4
        ) {
          isError = false;
        }

        if (isError) {
          context.dispatch("act008supplCertn", {
            code: this.state.common.supplCertn.cmmCertn.appInfo.SSGenerateMotp.errorcode,
            msg: "MOTP-CERTN-16",
            errBtnText: "",
            errBtnAction: "",
          });
        }

        if (Number(this.state.common.supplCertn.cmmCertn.appInfo.SSGenerateMotp.failcount) >= 5) {
          context.dispatch("act010supplCertn"); // 인증종료 ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
        }

        // 타이머 초기화
        context.dispatch("act013supplCertn");
      }
    },
    /**
     * mPin오류누적(5회) 데이터 업데이트
     */
    act010supplCertn: function() {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/certn/updateMpinErr",
          { iD: this.state.common.supplCertn.cmmCertn.svrInfo.success.mOtpInfo.iD },
          response => {
            this.state.common.supplCertn.isOpenSupplCertn = false;
            resolve("success", response);
          },
          response => {
            this.state.common.supplCertn.isOpenSupplCertn = false;
            resolve("fail", response);
          },
        );
      });
    },
    /**
     * 인증코드 화면노출 타이머
     */
    act012supplCertn: function(context) {
      tid = setInterval(() => {
        this.state.common.supplCertn.sendTime--;
        if (this.state.common.supplCertn.sendTime === 0) {
          clearInterval(tid);
          context.commit("mut005supplCertn");
          // 최초 이후 인증번호 받아오는 경우.(native 키패드 열림 없음)
          context.dispatch("act005supplCertn", "SSGenerateMotp_supplCertn_ReGenerate");
        }
      }, 1000);
    },
    /**
     * 타이머 초기화..
     */
    act013supplCertn: function() {
      this._vm.$log.info("타이머초기화");
      this.state.common.supplCertn.sendTime = timerSeconds;
      clearInterval(tid);
    },
    /**
     * 인증수단 조회 - 로그인
     */
    act014supplCertn: function(context, payload) {
      // this._vm.$log.info(">>> " + context.state.cmmCertn);
      // this._vm.$log.info(">>> " + JSON.stringify(payload));
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/comm/certn/getCommCertn",
          payload,
          response => {
            this._vm.$set(context.state.cmmCertn.svrInfo, "success", response);
            resolve("success");
          },
          response => {
            this._vm.$set(context.state.cmmCertn.svrInfo, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * 인증수단 조회 - 비로그인
     */
    act015supplCertn: function(context, payload) {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/comm/certn/getCommCertnForNLogin",
          payload,
          response => {
            this._vm.$set(context.state.cmmCertn.svrInfo, "success", response);
            resolve("success");
          },
          response => {
            this._vm.$set(context.state.cmmCertn.svrInfo, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * Fido App success callback
     */
    act016supplCertn: function(context) {
      // this._vm.$log.info("appReqOut >> " + JSON.stringify(this.state.auth.createFido.fidoCertn.appReq.out));
      context.dispatch("act002supplCertn");
    },
    /**
     * fido 인증요청
     */
    act017supplCertn: function(context, payload) {
      return new Promise(resolve => {
        this._vm.$post("/auth/fido/certn/UafCertnRequest", payload, response => {
          resolve(response);
        });
      });
    },
  },
};

export default supplCertn;
